import React from "react";
import { UserCheck, TrendingUp, Truck, BarChart3 } from "lucide-react";

const TrustedSection = () => {
  const stats = [
    {
      icon: <UserCheck className="w-6 h-6 text-green-900" />,
      value: "95%",
      label: "Customer Satisfaction",
    },
    {
      icon: <TrendingUp className="w-6 h-6 text-green-900" />,
      value: "300+",
      label: "Top-rated Vendors",
    },
    {
      icon: <Truck className="w-6 h-6 text-green-900" />,
      value: "3000+",
      label: "Bulk Orders Delivered",
    },
    {
      icon: <BarChart3 className="w-6 h-6 text-green-900" />,
      value: "75%",
      label: "Daily Growing",
    },
  ];

  return (
    <section className="bg-gradient-to-b from-green-50 to-green-100 py-20 px-6 md:px-12">
      <div className="max-w-6xl mx-auto text-center">
        {/* Heading */}
        <h2 className="text-3xl md:text-4xl font-extrabold text-green-900">
          Trusted By Everyone
        </h2>
        <p className="text-gray-700 mt-4 max-w-2xl mx-auto text-lg">
          Empowering thousands of retail businesses with smart sourcing, timely
          delivery, and unbeatable wholesale prices.
        </p>

        {/* White Container with Cards */}
        <div className="mt-12 bg-white rounded-3xl shadow-xl border border-green-100 p-10">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8">
            {stats.map((item, index) => (
              <div
                key={index}
                className="bg-green-50 rounded-2xl shadow-md p-8 flex flex-col items-center transition transform hover:scale-105 hover:shadow-lg"
              >
                <div className="bg-green-100 p-4 rounded-full flex items-center justify-center">
                  {item.icon}
                </div>
                <h3 className="text-3xl font-bold text-green-900 mt-4">
                  {item.value}
                </h3>
                <p className="text-green-700 mt-2 text-base font-medium">
                  {item.label}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustedSection;
